/* eslint-disable no-unused-expressions */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Badge, Dropdown, Table } from 'antd';
import {
  CaretDownFilled,
  CaretRightFilled,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import imageDefault from '@Images/icons/imageDefault.png';
import './style.scss';
import { QUANTITY } from '@Apis/constants';

const getDataSource = (data) => {
  const finalLines = [];
  const productSkuTenantIdMapping = {};

  if (data) {
    data.map((uf) => {
      const lines = uf.fulfillment_lines;
      const assignedLocationId = uf.assigned_shopify_location_id;
      const tenantInfo = uf.tenant_info;
      const fulfillmentId = uf.fulfillment_id;

      for (let i = 0; i < lines?.length; i++) {
        const availableLocations = lines[i]?.available_locations;
        for (let j = 0; j < availableLocations?.length; j++) {
          if (productSkuTenantIdMapping.hasOwnProperty(lines[i]?.product_sku_id)) {
            productSkuTenantIdMapping[lines[i]?.product_sku_id].push({
              ...availableLocations[j],
            });
          } else {
            productSkuTenantIdMapping[lines[i]?.product_sku_id] = [{
              ...availableLocations[j],
            }];
          }
        }
      }

      finalLines.push({
        assigned_shopify_location_id: assignedLocationId, ...tenantInfo, ffId: fulfillmentId, productSkuTenantIdMapping,
      });
      lines.map((line) => finalLines.push(line));
    });
  }
  return finalLines;
};

function UnFulfilledLines(props) {

  const {
    unfulfilledFulfillments, MONEY, soMapping, user, handleDrawerState1, handleDrawerState2
  } = props;

  const [state, setState] = useState({
    showFulfillmentOptions: false,
  });

  const updateState = (newState) => {
    setState((oldState) => ({
      ...oldState,
      ...newState,
    }));
  };

  const {
    showFulfillmentOptions
  } = state;

  const unFulfilledColumns = [
    {
      title: '',
      width: '60px',
      render: (record) => ({
        props: { style: { backgroundColor: !record?.fulfillment_id ? '#ABE09835' : 'white' } },
        children: (
          <div>
            {record?.fulfillment_id ? (
              <div style={{ width: '50px', height: '40px' }}>
                <img style={{ width: '40px', height: '40px', opacity: record?.tenant_product_info?.product_sku_info?.assets?.[0]?.url ? 1 : 0.15 }} src={`${record?.tenant_product_info?.product_sku_info?.assets?.[0]?.url ? record?.tenant_product_info?.product_sku_info?.assets?.[0]?.url : imageDefault}`} />
                <Badge
                  className="unfulfilled-qty__badge"
                  count={QUANTITY(record?.fulfillable_quantity, record?.uom_info?.[0]?.precision)}
                />
              </div>
            ) : (
              <div className="uff-table__location-wrapper">
                <div className="uff-table__fg-name">
                  {record?.tenant_name}
                  {' '}
                  <CaretRightFilled />
                </div>
                <div className="uff-table__location-wrapper__actions">
                  <div className="filters__buttons">
                    <Dropdown
                      overlay={(
                        <div className="header__custom-dropdown" style={{ width: '150px' }}>
                          <H3Text
                            text="Fulfill Items"
                            className="header__custom-dropdown__option"
                            onClick={() => {
                              handleDrawerState2(record?.assigned_shopify_location_id, record?.ffId);
                            }}
                          />
                          <H3Text
                            text="Change Location"
                            className="header__custom-dropdown__option"
                            onClick={() => {
                              handleDrawerState1(record?.assigned_shopify_location_id, record?.ffId, record?.productSkuTenantIdMapping, record?.tenant_id);
                            }}
                          />
                        </div>
                      )}
                    >
                      <div className="filter__button" style={{ fontSize: '12px' }} onClick={() => updateState({ showFulfillmentOptions: !showFulfillmentOptions })}>
                        More
                        <CaretDownFilled />
                      </div>
                    </Dropdown>
                  </div>
                </div>
              </div>
            )}
          </div>),
      }),
      onCell: (item) => {
        if (!item?.fulfillment_id) {
          return { colSpan: 7 };
        }
        return {};
      },
    },
    {
      title: 'PRODUCT',
      render: (item) => {

        const qty = soMapping?.[`${item?.tenant_product_info?.product_sku_info.product_sku_id}`]?.[0].unit_price;
        const total = soMapping?.[`${item?.tenant_product_info?.product_sku_info.product_sku_id}`]?.[0].unit_price * item?.fulfillable_quantity;
        const taxValue = soMapping?.[`${item?.tenant_product_info?.product_sku_info.product_sku_id}`]?.[0]?.tax_info?.tax_value;
        return (
          <div className="unfulfilled__product-info__wrapper">
            <div className="unfulfilled__product-info">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Link
                  to={`/inventory/product/view/${item?.tenant_product_info?.product_sku_info?.product_sku_id}`}
                  target="_blank"
                >
                  <span style={{ fontSize: '11px' }}>
                    #
                    {item?.tenant_product_info?.product_sku_info?.internal_sku_code}
                  </span>
                </Link>
                {user?.tenant_info?.global_config?.settings?.marketplace_enabled && item?.tenant_product_info?.default_sku_offer?.seller_id && (
                  <div className="unfulfilled-qr__status" style={{ backgroundColor: '#f58428' }}>
                    MP
                  </div>
                )}
              </div>
              {item?.tenant_product_info?.product_sku_info?.product_sku_name}
              {user?.tenant_info?.global_config?.settings?.marketplace_enabled && item?.tenant_product_info?.default_sku_offer?.seller_id && (
                <div>
                  <H3Text
                    text={<a href={`/vendors/view/${item?.tenant_product_info?.default_sku_offer?.seller_id}`} target="_blank" rel="noreferrer">{`#${item?.tenant_product_info?.default_sku_offer?.internal_slr_code} - ${item?.tenant_product_info?.default_sku_offer?.seller_name?.toProperCase()}`}</a>}
                    className="unfulfilled__field-value"
                  />
                </div>
              )}
              {(item?.bundle_products?.length > 0) && <H3Text text="Bundle" className="table-subscript table-subscript-tag" />}
              <H3Text text={item.remarks} className="quotation__remarks" />
            </div>
            <div className="unfulfilled__product-pricing">
              {`${QUANTITY(item?.fulfillable_quantity, item?.uom_info?.[0]?.precision)} ${soMapping?.[`${item?.tenant_product_info?.product_sku_info.product_sku_id}`]?.[0]?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              &nbsp;
              x
              &nbsp;
              {MONEY(qty + ((qty * taxValue) / 100))}
            </div>
          </div>
        );
      },
      onCell: (item) => {
        if (!item?.fulfillment_id) {
          return { colSpan: 0 };
        }
        return { colSpan: 6 };
      },
    },
  ];

  const bundleListColumns = [
    {
      title: 'SKU#',
      render: (record) => (
        <Link to={`/inventory/product/view/${record?.tenant_product_info?.product_sku_info?.product_sku_id}`} target="_blank">
          {record?.tenant_product_info?.product_sku_info?.internal_sku_code}
        </Link>
      ),
    },
    {
      title: 'PRODUCT',
      render: (text, record) => (
        <div className="so-table__product-name">
          {record?.tenant_product_info?.product_sku_info?.product_sku_name}
        </div>
      ),
    },
    {
      title: 'QUANTITY',
      dataIndex: 'quantity',
      render: (text, record) => (
        <div className="so-qty-input">
          {`${record?.bundle_quantity} ${record?.tenant_product_info?.product_sku_info?.uom_info?.uqc?.toProperCase()}`}
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="view-so-uff-table-wrapper">
        <Table
          showHeader
          title={() => `Pending Items (${getDataSource(unfulfilledFulfillments)?.filter((item) => item?.fulfillment_id)?.length || 0})`}
          size="small"
          columns={unFulfilledColumns}
          dataSource={getDataSource(unfulfilledFulfillments)}
          pagination={false}
          bordered
          scroll={{ x: true }}
          expandable={{
            rowExpandable: (record) => record?.bundle_products?.length,
            defaultExpandAllRows: true,
            expandedRowRender: (record) => (
              <div className="view-bundle__inner-table">
                <Table
                  bordered
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={bundleListColumns}
                  dataSource={record?.bundle_products?.map((item) => ({
                    ...item,
                    bundle_quantity: parseFloat(item?.quantity || '0'),
                  }))}
                  pagination={false}
                />
              </div>
            ),
          }}
        />
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({

});

UnFulfilledLines.propTypes = {
  user: PropTypes.any,
  unfulfilledFulfillments: PropTypes.any,
  handleDrawerState1: PropTypes.any,
  handleDrawerState2: PropTypes.any,
  soMapping: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnFulfilledLines));
